import BaseModelAPI from '../BaseModelAPI';

export default class DeliveryInstructionStatusList extends BaseModelAPI {

	static entity = 'deliveryinstructionstatuslist'
	static entityName = 'deliveryinstructionstatus';

	constructor() {
		this.pageIndex = 0;
		this.pageSize = 0;
		this.pageCount = 0;
		this.dataCount = 0;
	}
}
